module.exports = __webpack_public_path__ + "media/pdfs/diploma-31564197ad86a8d21ef24e06f85b3b09.pdf";